import * as React from 'react';
import ParticipationInfo from '../../components/member/participation-info';
import SeasonParticipant from '../../models/season-participant';

export interface Props {
  orgId: number;
  memberId: number;
  seasonParticipants: SeasonParticipant[];
}

const MemberParticipationOverview: React.FunctionComponent<Props> = ({ seasonParticipants, orgId, memberId }) => {
  let membersProgramContent;
  if (seasonParticipants?.length == 0) {
    membersProgramContent = (
      <>
        <div className="Panel-row u-textBold">Programs</div>
        <div className="Panel-row">There are no programs for this member.</div>
      </>
    );
  } else {
    membersProgramContent = (
      <>
        <div className="Panel-row">
          <div className="Grid Grid--fit Grid--withGutter">
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">Program</p>
            </div>
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">Team/Division</p>
            </div>
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">Role</p>
            </div>
            <div className="Grid-cell">
              <p className="u-pad u-textSemiBold">Registration</p>
            </div>
            <div className="Grid-cell"></div>
          </div>
        </div>
        {seasonParticipants?.map((seasonParticipant, idx) => (
          <div className="Panel-row">
            <ParticipationInfo
              orgId={+orgId}
              seasonParticipant={seasonParticipant}
              key={`participation-info-${idx}`}
            />
          </div>
        ))}
      </>
    );
  }
  return (
    <>
      {seasonParticipants && (
        <div className={`Panel ${seasonParticipants?.length > 0 ? 'Panel--striped' : ''}`}>
          <div className="Panel-body">{membersProgramContent}</div>
        </div>
      )}
    </>
  );
};

export default MemberParticipationOverview;
